import { downloadFile, mapPaginationParamsToServer, format } from "@/shared";

import { mapExpenseFiltersToServer } from "./mappers/mapExpenseFiltersToServer";

export const exportExpenses = async (paginationParams, filters) => {
    const fileName = `exported_expenses_${format(
        new Date(),
        "dd_MM_yyyy-HH_mm"
    )}`;

    await downloadFile("expense/export", fileName, {
        ...mapPaginationParamsToServer(paginationParams),
        ...mapExpenseFiltersToServer(filters),
    });
};
